import { useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getSmsDashboardConversationsKey } from './useConversations';

import type { IConversationsListPages } from 'infrastructure/interfaces';
import type { RootState } from 'store';

interface ISocketData {
  conversationId: number;
  assignedAt: number | null;
  assignedByFullname: string;
  assignedByLogin: string;
}

export const useUpdateAssignConversationState = () => {
  const queryClient = useQueryClient();
  const { conversationType, filters } = useSelector(
    (state: RootState) => state.smsDashboard,
  );

  const updateAssignConversationState = (socketData: ISocketData) => {
    const conversationKey = getSmsDashboardConversationsKey({
      type: conversationType,
      read: filters.read,
      closed: filters.closed,
      lastMessageDate: filters.lastMessageDate,
      searchQuery: filters.searchQuery,
      assignedToMe: false,
      onlyNeedFilters: true,
    });

    queryClient.setQueriesData<IConversationsListPages>(
      { queryKey: [conversationKey[0]] },
      (oldData) => {
        if (!oldData) return oldData;

        const updatedPages = oldData.pages.map((page) => {
          const updatedItems = page.items.map((item) => {
            if (item.id !== socketData.conversationId) return item;

            return {
              ...item,
              assignedAt: socketData.assignedAt
                ? new Date(socketData.assignedAt).toISOString()
                : null,
              assignedByFullname: socketData.assignedByFullname,
              assignedByLogin: socketData.assignedByLogin,
            };
          });

          return { ...page, items: updatedItems };
        });

        return { ...oldData, pages: updatedPages };
      },
    );
  };

  return { updateAssignConversationState };
};
